// src\stores\index.tsx
import { configureStore } from "@reduxjs/toolkit";
import authReducer, { logout } from "./authSlice";
import loadingSlice from "./loadingSlice";
import notificationSlice from "./notificationSlice";
import { configureAxiosStore } from "@/services/axiosInstance";
// import { throttle } from "lodash"

const store = configureStore({
  reducer: {
    auth: authReducer,
    loading: loadingSlice,
    notifications: notificationSlice,
  },
});

configureAxiosStore(store.dispatch, logout);

/*
store.subscribe(throttle(() => {
  const state = store.getState();
  localStorage.setItem("reduxState", JSON.stringify(state));
}, 1000));
*/


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
